/**
 * Send Video-Call Gift UseCase
 *
 * Video-call-gift variant: media-less, chatInfo-less transaction carrying
 * `chatVideoCallInfo`, a null notification and a computed `groupChatId`.
 * Resolves the peer from the call's caller/audience users. Mirrors the chat
 * path (SendChatGiftUseCase) otherwise. Validates inputs, delegates to
 * GiftService and refreshes the local wallet on success.
 *
 * Flutter source: video_call_screen.dart:1163-1202 + send_gift_bottom_sheet.dart:159-223
 */
import type { SendVideoCallGiftInput } from '@/domain/input/gift/sendVideoCallGiftInput';
import type { GiftService } from '@/domain/services/gift/giftService';
import { RefreshWalletUseCase } from '@/domain/usecases/wallet/refreshWalletUseCase';

export class SendVideoCallGiftUseCase {
  constructor(
    private readonly giftService: GiftService,
    private readonly refreshWalletUseCase: RefreshWalletUseCase = new RefreshWalletUseCase(),
  ) {}

  async execute(input: SendVideoCallGiftInput): Promise<boolean> {
    if (input.instances <= 0) return false;

    const success = await this.giftService.executeSendVideoCallGift(input);

    if (success) {
      this.refreshWalletUseCase.execute();
    }

    return success;
  }
}
